import React from 'react';
import AgioLogo from '@/assets/svg/agio-logo-small.svg?react';

import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { TopNavigation } from '@/layouts/MainLayout/components/Sidebar/components/TopNavigation/TopNavigation';
import { BottomNavigation } from '@/layouts/MainLayout/components/Sidebar/components/BottomNavigation/BottomNavigation';
import {
  StyledContainer,
  StyledNewLogoWrapper,
  StyledChevronIcon,
  StyledCloseButton,
  StyledLogoLink,
} from '@/layouts/MainLayout/components/Sidebar/Sidebar.styled';
import { ERoutes } from '@/types/routes';

interface ISidebarProps {
  handleMenuToggle: () => void;
}

export const Sidebar = ({ handleMenuToggle }: ISidebarProps) => {
  const { isDesktop } = useBreakpointsCtx();

  return (
    <>
      {!isDesktop && (
        <StyledCloseButton onClick={handleMenuToggle}>
          <StyledChevronIcon color="inherit" />
        </StyledCloseButton>
      )}

      <StyledNewLogoWrapper>
        <StyledLogoLink to={ERoutes.RATINGS}>
          <AgioLogo width="100%" height="100%" />
        </StyledLogoLink>
      </StyledNewLogoWrapper>

      <StyledContainer>
        <TopNavigation handleMenuToggle={handleMenuToggle} />
        <BottomNavigation />
      </StyledContainer>
    </>
  );
};
